/*global navigator*/
/* eslint-disable react/no-multi-comp */

import React from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import classie from 'classie';
import Cookies from 'js-cookie';
import * as querystring from 'qs';
import autobind from 'autobind-decorator';

import {withConfig, withI18n} from 'spa/Components/Context';
import {browserOnly} from 'spa/Components/EnvSplit';

const DISMISSED_SMART_BANNER_COOKIE_NAME = 'hidesb';

@browserOnly
@inject(({
  store: {
    tracker,
    umDeviceIdentifier,
    userAgent,
    utmCookie,
  },
}) => ({
  tracker,
  umDeviceIdentifier,
  userAgent,
  utmCookie,
}))
@withConfig
@withI18n
class SmartBanner extends React.Component {
  static propTypes = {
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    umDeviceIdentifier: PropTypes.string,
    userAgent: PropTypes.string.isRequired,
    utmCookie: PropTypes.object,
  }

  get adjustUrl() {
    const {config, i18n} = this.context;
    const {umDeviceIdentifier, utmCookie} = this.props;

    this.downloadAppsLink = config.getValue('locale.adjust-app-smartbanner-url', i18n.umRegion);

    let queryObject = {
      umDeviceIdentifier,
    };

    if (utmCookie) {
      queryObject = Object.assign(utmCookie, queryObject);
    }

    return `${this.downloadAppsLink}?label=${encodeURIComponent(querystring.stringify(queryObject))}`;
  }

  @autobind onClickDismiss(event) {
    const {tracker} = this.props;
    event.preventDefault();

    tracker.track('Smart Banner Dismissed', {
      category: 'Smart Banner',
    });

    Cookies.set(DISMISSED_SMART_BANNER_COOKIE_NAME, 'true', { expires: 90 });
    this.forceUpdate();
  }

  @autobind onClickSmartBanner(event) {
    const {adjustUrl} = this;
    const {tracker} = this.props;
    if (event) event.preventDefault();

    tracker.track('Smart Banner Clicked', {
      category: 'Smart Banner',
    });
    // Go to correct url and give tracker a little bit of time to fire first for older phones
    setTimeout(() => {
      window.location.href = adjustUrl;
    }, 300);
  }

  render() {
    const {adjustUrl} = this;
    if (typeof navigator === 'undefined') return null;
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (!isAndroid && !isIOS) { return null; }
    const dismissedSmartBanner = Cookies.get(DISMISSED_SMART_BANNER_COOKIE_NAME);
    if (dismissedSmartBanner) { return null; }

    return (
      <SmartBannerInner
        href={adjustUrl}
        isAndroid={isAndroid}
        onClickDismiss={this.onClickDismiss}
        onClickSmartBanner={this.onClickSmartBanner}
      />
    );
  }
}

@withI18n
@observer
class SmartBannerInner extends React.Component {
  static propTypes = {
    onClickDismiss: PropTypes.func.isRequired,
    onClickSmartBanner: PropTypes.func.isRequired,
    isAndroid: PropTypes.bool.isRequired,
    href: PropTypes.string.isRequired,
  };

  UNSAFE_componentWillMount() {
    classie.add(document.body, 'with-smart-banner');
  }
  componentWillUnmount() {
    classie.remove(document.body, 'with-smart-banner');
  }

  render() {
    const {i18n} = this.context;
    const {onClickDismiss, onClickSmartBanner} = this.props;
    return (
      <div className="smart-banner__container">
        <div className="smart-banner">
          <a
            className="smart-banner__dismiss"
            href="#dismiss-banner"
            onClick={onClickDismiss}
            title="Dismiss"
          />
          <div
            className="smart-banner__icon"
          >
            <img
              className="smart-banner__icon-img"
              src="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_80,h_80,q_60/v1495116286/b2c-art/optimised/UM_Monogram_NEG_RGB_itvwr8.png"
              alt=""
            />
          </div>
          <div className="smart-banner__content">
            <p className="smart-banner__title">{i18n._x('Urban', 'smart banner title')}</p>
            {this.props.isAndroid ? (
              <p className="smart-banner__cta">{i18n._x('Get it from the Play Store', 'smart banner subtitle')}</p>
            ) : (
              <p className="smart-banner__cta">{i18n._x('Get it from the App Store', 'smart banner subtitle')}</p>
            )}
          </div>
          <a className="smart-banner__link" href={this.props.href} onClick={onClickSmartBanner}>
            {i18n._x('View', 'smart banner button')}
          </a>
        </div>
      </div>
    );
  }
}

export default SmartBanner;



// WEBPACK FOOTER //
// ./spa/Components/SmartBanner.jsx